const LOGIN_UNKNOWN_ERROR_TEXT = "Une erreur est survenue.";
const LOGIN_BAD_CREDENTIALS_ERROR_TEXT = "Les identifiants fournis ne sont pas valides.";
const LOGIN_BAD_SERVER_ERROR_TEXT = "Problème de serveur... Vérifiez l'URL.";
const LOGOUT_ERROR_TEXT = "Une erreur est survenue.";
const RESET_PASSWORD_EMAIL_UNKNOWN_ERROR_TEXT = "Une erreur est survenue.";
const RESET_PASSWORD_EMAIL_USER_ERROR_TEXT = "L'e-mail fourni n'est pas valide.";
const RESET_PASSWORD_EMAIL_BAD_SERVER_ERROR_TEXT = "Problème de serveur... Vérifiez l'URL.";
const RESET_PASSWORD_CONFIRM_UNKNOWN_ERROR_TEXT = "Une erreur est survenue.";
const RESET_PASSWORD_CONFIRM_ERROR_TEXT = "Une erreur est survenue.";
const RESET_PASSWORD_CONFIRM_BAD_SERVER_ERROR_TEXT = "Problème de serveur... Vérifiez l'URL.";
const GET_CONNECTED_USER_UNKNOWN_ERROR_TEXT = "Une erreur est survenue.";
const GET_CONNECTED_USER_NOT_CONNECTED_ERROR_TEXT = "Vous devez vous authentifier.";
const GET_CONNECTED_USER_BAD_SERVER_ERROR_TEXT = "Problème de serveur... Vérifiez l'URL.";
const ADD_PUSH_NOTIFICATION_TOKEN_ERROR_TEXT = "Une erreur est survenue lors de l'enregistrement aux notifications.";
const GET_USER_SETTINGS_ERROR_TEXT = "Problème lors du chargements des paramètres utilisateur.";
const UPDATE_USER_SETTINGS_ERROR_TEXT = "Problème lors de la modification des paramètres utilisateur.";
const UPDATE_USER_PASSWORD_ERROR_TEXT = "Problème lors du changement du mot de passe.";

export const LOGIN_UNKNOWN_ERROR = LOGIN_UNKNOWN_ERROR_TEXT;
export const LOGIN_BAD_CREDENTIALS_ERROR = LOGIN_BAD_CREDENTIALS_ERROR_TEXT;
export const LOGIN_BAD_SERVER_ERROR = LOGIN_BAD_SERVER_ERROR_TEXT;
export const LOGOUT_ERROR = LOGOUT_ERROR_TEXT;
export const RESET_PASSWORD_EMAIL_UNKNOWN_ERROR = RESET_PASSWORD_EMAIL_UNKNOWN_ERROR_TEXT;
export const RESET_PASSWORD_EMAIL_USER_ERROR = RESET_PASSWORD_EMAIL_USER_ERROR_TEXT;
export const RESET_PASSWORD_EMAIL_BAD_SERVER_ERROR = RESET_PASSWORD_EMAIL_BAD_SERVER_ERROR_TEXT;
export const RESET_PASSWORD_CONFIRM_UNKNOWN_ERROR = RESET_PASSWORD_CONFIRM_UNKNOWN_ERROR_TEXT;
export const RESET_PASSWORD_CONFIRM_ERROR = RESET_PASSWORD_CONFIRM_ERROR_TEXT;
export const RESET_PASSWORD_CONFIRM_BAD_SERVER_ERROR = RESET_PASSWORD_CONFIRM_BAD_SERVER_ERROR_TEXT;
export const GET_CONNECTED_USER_UNKNOWN_ERROR = GET_CONNECTED_USER_UNKNOWN_ERROR_TEXT;
export const GET_CONNECTED_USER_NOT_CONNECTED_ERROR = GET_CONNECTED_USER_NOT_CONNECTED_ERROR_TEXT;
export const GET_CONNECTED_USER_BAD_SERVER_ERROR = GET_CONNECTED_USER_BAD_SERVER_ERROR_TEXT;
export const ADD_PUSH_NOTIFICATION_TOKEN_ERROR = ADD_PUSH_NOTIFICATION_TOKEN_ERROR_TEXT;
export const GET_USER_SETTINGS_ERROR = GET_USER_SETTINGS_ERROR_TEXT;
export const UPDATE_USER_SETTINGS_ERROR = UPDATE_USER_SETTINGS_ERROR_TEXT;
export const UPDATE_USER_PASSWORD_ERROR = UPDATE_USER_PASSWORD_ERROR_TEXT;


// WEBPACK FOOTER //
// ./src/errors/authentication.js